import { Injectable } from '@angular/core'
import { environment } from 'src/environments/environment'
import StackdriverErrorReporter from 'stackdriver-errors-js'

export enum LoggingSeverity {
  INFO = 'INFO',
  WARNING = 'WARNING',
  ERROR = 'ERROR'
}

@Injectable({
  providedIn: 'root'
})
export class LoggingService {
  private errorHandler: StackdriverErrorReporter

  constructor() {
    if (environment.production && environment.googleConfig) {
      const key = environment.googleConfig?.apiKey
      const projectId = environment.googleConfig?.projectId
      const serviceName = environment.service || ''

      this.errorHandler = new StackdriverErrorReporter()
      this.errorHandler.start({
        key,
        projectId,
        service: serviceName
      })
    }
  }

  public async reportError(err: Error) {
    if (err) {
      console.error(err)
      if (
        environment.production &&
        environment.googleConfig &&
        environment.googleConfig.apiKey
      ) {
        try {
          await this.errorHandler.report(err)
        } catch (error) {
          await this.errorHandler.report(
            `Stackdriver report error for error: ${err?.message} and stackdriver error: ${error?.message}`
          )
          console.warn('Failed to report error to Stackdriver:', error)
        }
      }
    } else {
      console.log('Report error called without an error')
    }
  }
}
